import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-customer-value-expense-partition',
  templateUrl: './customer-value-expense-partition.component.html',
  styleUrls: ['./customer-value-expense-partition.component.css']
})
export class CustomerValueExpensePartitionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customer-value/customer-value-expense-partition/customer-value-expense-partition.component.ts